import { Injectable, Inject, InjectionToken, Optional } from '@angular/core';

export const CONFIGURATION_CLASSES = new InjectionToken<any[]>('CONFIGURATION_CLASSES');

@Injectable()
export class ConfigurationService {
	private readonly configurations;

	constructor(@Optional() @Inject(CONFIGURATION_CLASSES) configurationClasses: any[]) {
		this.configurations = configurationClasses;
	}
}
